import React from 'react';
import { Tooltip } from '@mantine/core';

export const PERMISSION_RESTRICTED_MESSAGE = 'Permissions are restricted for this action.';

export interface PermissionRestrictedTooltipProps {
  /** When true, the action is blocked by permissions and the tooltip is shown. */
  restricted: boolean;
  label?: string;
  children: React.ReactNode;
  /** Pass through when the wrapper needs a block layout (full-width buttons). */
  fullWidth?: boolean;
}

/**
 * Wraps a control so a permission tooltip still works when the child is disabled
 * (disabled elements do not fire pointer events).
 */
export function PermissionRestrictedTooltip({
  restricted,
  label = PERMISSION_RESTRICTED_MESSAGE,
  children,
  fullWidth = false,
}: PermissionRestrictedTooltipProps) {
  return (
    <Tooltip label={label} disabled={!restricted} withArrow multiline maw={260}>
      <span
        style={{
          display: fullWidth ? 'block' : 'inline-flex',
          width: fullWidth ? '100%' : undefined,
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
}
